export const translations = {
  en: {
    // Navigation
    home: "Home",
    search: "Search",
    doctors: "Doctors",
    appointments: "Appointments", 
    records: "Records",
    messages: "Messages",
    notifications: "Notifications",
    clinicDashboard: "Clinic Dashboard",
    signIn: "Sign In",
    logout: "Logout",

    // Doctor-related translations
    findDoctor: "Find a Doctor",
    filterBySpeciality: "Filter by Speciality",
    allSpecialities: "All Specialities",
    loadingDoctors: "Loading doctors...",
    experience: "Experience",
    years: "years",
    consultationFee: "Consultation Fee",
    rating: "Rating",
    reviews: "reviews",
    clinic: "Clinic",
    viewProfileBook: "View Profile & Book",
    doctorNotFound: "Doctor not found",
    backToDoctors: "Back to Doctors",
    bookAppointment: "Book Appointment",
    symptomsReason: "Symptoms or Reason for Visit (Optional)",
    describeSymptomsPlaceholder: "Describe your symptoms or reason for the appointment...",
    bookAppointmentFee: "Book Appointment - ${{fee}}",
    signInToBook: "Please sign in to book an appointment",
    
    // Home Page
    heroTitle: "Book Healthcare Appointments Instantly",
    heroSubtitle: "Connect with verified doctors, beauty specialists, and dental experts. Book appointments, manage medical records, and get the care you need.",
    findProviders: "Find Healthcare Providers",
    browseDoctors: "Browse Doctors",
    newPlatform: "New Platform",
    healthcareMadeSimple: "Healthcare Made Simple",
    
    // Stats
    verifiedProviders: "Verified Healthcare Providers",
    appointmentsBooked: "Appointments Booked", 
    happyPatients: "Happy Users",
    
    // Services
    comprehensiveServices: "Comprehensive Healthcare Services",
    servicesSubtitle: "From medical care to beauty treatments and dental services",
    medicalCare: "Medical Care",
    medicalCareDesc: "General practice, specialists, urgent care, and telemedicine consultations.",
    beautyAesthetics: "Beauty & Aesthetics",
    beautyAestheticsDesc: "Professional beauty treatments, cosmetic procedures, and wellness services.",
    dentalCare: "Dental Care",
    dentalCareDesc: "Complete dental services from routine cleanings to cosmetic dentistry.",
    
    // Featured Doctors
    featuredProviders: "Featured Healthcare Providers",
    featuredProvidersSubtitle: "Meet our experienced medical professionals",
    yearsExperience: "years experience",
    consultation: "consultation",
    bookAppointment: "Book Appointment",
    viewAllProviders: "View All Healthcare Providers",
    
    // Authentication
    continueWithGoogle: "Continue with Google",
    continueWithPhone: "Or continue with phone",
    phoneNumber: "Phone Number",
    sendCode: "Send Verification Code",
    verificationCode: "Verification Code",
    verifyCode: "Verify Code",
    changePhone: "Change Phone Number",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    
    // Logout
    logout: "Logout",
    loggingOut: "Logging out...",
    completeLogout: "Complete Logout",
    signOutAllDevices: "Sign out from all devices",
    logoutAs: "Logout as",
    keepOtherRoles: "Keep other roles active",
    emergencyLogout: "Emergency Logout",
    clearAllData: "Clear all data & sessions",
    logoutSecurityNote: "For security, logout will clear all cached medical data",
    searchSubtitle: "Find doctors, clinics, and healthcare services near you",
    allSpecialities: "All Specialities",
    noResults: "No results found",
    adjustSearch: "Try adjusting your search terms or filters",
    searchHealthcareProviders: "Search Healthcare Providers",
    findDoctorsClinicsServices: "Find doctors, clinics, and healthcare services near you",
    searchDoctorsClinics: "Search doctors, clinics...",
    allResults: "All",
    doctorsResults: "Doctors",
    clinicsResults: "Clinics",
    searchButton: "Search",
    searching: "Searching...",
    resultsFound: "results found",
    
    // Appointments
    myAppointments: "My Appointments",
    noAppointments: "No appointments found",
    noAppointmentsDesc: "You haven't booked any appointments yet.",
    findDoctor: "Find a Doctor",
    appointmentConfirmed: "Appointment confirmed successfully!",
    
    // Medical Records
    medicalRecords: "Medical Records",
    medicalRecordsSubtitle: "Manage and share your medical records securely",
    uploadRecord: "Upload Record",
    myRecords: "My Records",
    sharedRecords: "Shared Records",
    noRecordsFound: "No Medical Records",
    uploadFirst: "Upload your first medical record to get started",
    
    // Clinic Dashboard
    clinicDashboard: "Clinic Dashboard",
    manageAppointments: "Manage appointments, schedules, and clinic settings",
    calendarView: "Calendar View",
    locationSettings: "Location Settings",
    confirmAppointment: "Confirm",
    rescheduleAppointment: "Reschedule",
    sendSMS: "Send SMS",
    
    // Common
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    submit: "Submit",
    close: "Close",
    view: "View",
    download: "Download",
    share: "Share",
    date: "Date",
    time: "Time",
    status: "Status",
    payment: "Payment",
    fee: "Fee",
    experience: "Experience",
    rating: "Rating",
    location: "Location",
    about: "About",
    symptoms: "Symptoms",
    
    // Status
    pending: "Pending",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    paid: "Paid",
    failed: "Failed",
    
    // Notifications
    newMessage: "New message from",
    appointmentConfirmedNotif: "Your appointment has been confirmed",
    appointmentRescheduled: "Your appointment has been rescheduled",
    reminderNotif: "Reminder: You have an appointment tomorrow",
    markAllRead: "Mark all as read",
    viewAllNotifications: "View All Notifications",
    noNotifications: "No notifications",
    
    // Messages
    inbox: "Inbox",
    newMessage: "New Message",
    sendMessage: "Send Message",
    typeMessage: "Type your message...",
    noMessages: "No messages",
    startConversation: "Start a conversation",
    
    // Language
    language: "Language",
    english: "English",
    arabic: "العربية",

    // Footer
    footerDescription: "Your trusted healthcare platform connecting users with verified medical professionals. Quality care, made accessible.",
    quickLinks: "Quick Links",
    services: "Services",
    onlineConsultation: "Online Consultation",
    languageSettings: "Language",
    contact: "Contact",
    allRightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",

    // About Us
    aboutUs: "About Us",
    aboutUsTitle: "About EnayaHub",
    aboutUsSubtitle: "We're revolutionizing healthcare by making quality medical care accessible to everyone, everywhere.",
    ourMission: "Our Mission",
    missionDescription: "At EnayaHub, we believe that quality healthcare should be accessible to everyone. Our mission is to bridge the gap between users and healthcare providers through innovative technology, creating a seamless and efficient healthcare experience for all.",
    accessibleHealthcare: "Making healthcare accessible to everyone",
    qualityAndSafety: "Ensuring quality and safety in every interaction",
    innovativeTechnology: "Using cutting-edge technology for better outcomes",
    ourValues: "Our Values",
    compassion: "Compassion",
    compassionDescription: "We care deeply about every user's journey and strive to provide empathetic, personalized care.",
    excellence: "Excellence",
    excellenceDescription: "We maintain the highest standards in everything we do, from our platform to our provider network.",
    innovation: "Innovation",
    innovationDescription: "We continuously evolve our technology to improve healthcare delivery and user outcomes.",
    ourTeam: "Our Team",
    teamDescription: "Our dedicated team of healthcare professionals, technologists, and innovators work tirelessly to improve healthcare access.",
    ceo: "Chief Executive Officer",
    ceoDescription: "Leading our mission to transform healthcare accessibility globally.",
    cto: "Chief Technology Officer", 
    ctoDescription: "Driving innovation and technical excellence in our platform.",
    cmo: "Chief Medical Officer",
    cmoDescription: "Ensuring medical quality and safety in all our services.",

    // Demo Login
    demoMode: "Demo Mode",
    demoModeDescription: "Test the platform with different user roles without registration",
    selectRole: "Select a role to test:",
    patient: "User",
    doctor: "Doctor", 
    provider: "Provider",
    account: "Account",
    cancel: "Cancel",
    loginAsDemo: "Login as Demo",
    demoModeNote: "Demo data is for testing purposes only",

    // Join as Provider
    joinAsProvider: "Join Our Provider Network",
    joinAsProviderSubtitle: "Expand your practice and reach more users with our comprehensive healthcare platform.",
    increasePatientBase: "Increase your user base and visibility",
    streamlineScheduling: "Streamline appointment scheduling and management",
    digitalPresence: "Build a strong digital presence for your practice",
    securePayments: "Secure payment processing and record keeping",
    joinNow: "Join Now",
    learnMore: "Learn More"
  },
  
  ar: {
    // Navigation  
    home: "الرئيسية",
    search: "البحث",
    doctors: "الأطباء", 
    appointments: "المواعيد",
    records: "السجلات",
    messages: "الرسائل",
    notifications: "الإشعارات",
    clinicDashboard: "لوحة العيادة",
    signIn: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    
    // Home Page
    heroTitle: "احجز مواعيد الرعاية الصحية فوراً",
    heroSubtitle: "تواصل مع أطباء معتمدين وأخصائيي تجميل وخبراء أسنان. احجز مواعيد وأدر سجلاتك الطبية واحصل على الرعاية التي تحتاجها.",
    findProviders: "العثور على مقدمي الرعاية الصحية",
    browseDoctors: "تصفح الأطباء",
    newPlatform: "منصة جديدة",
    healthcareMadeSimple: "الرعاية الصحية مبسطة",
    
    // Stats
    verifiedProviders: "مقدمو رعاية صحية معتمدون",
    appointmentsBooked: "مواعيد محجوزة",
    happyPatients: "مرضى سعداء",
    
    // Services
    comprehensiveServices: "خدمات رعاية صحية شاملة",
    servicesSubtitle: "من الرعاية الطبية إلى علاجات التجميل وخدمات الأسنان",
    medicalCare: "الرعاية الطبية",
    medicalCareDesc: "الممارسة العامة والأخصائيون والرعاية العاجلة والاستشارات الطبية عن بُعد.",
    beautyAesthetics: "التجميل والجماليات",
    beautyAestheticsDesc: "علاجات تجميل احترافية وإجراءات تجميلية وخدمات عافية.",
    dentalCare: "رعاية الأسنان", 
    dentalCareDesc: "خدمات أسنان كاملة من التنظيف الروتيني إلى طب الأسنان التجميلي.",
    
    // Featured Doctors
    featuredProviders: "مقدمو رعاية صحية مميزون",
    featuredProvidersSubtitle: "تعرف على أطبائنا ذوي الخبرة",
    yearsExperience: "سنوات خبرة",
    consultation: "استشارة",
    bookAppointment: "احجز موعد",
    viewAllProviders: "عرض جميع مقدمي الرعاية الصحية",
    
    // Doctor-related translations
    findDoctor: "البحث عن طبيب",
    filterBySpeciality: "تصفية حسب التخصص",
    allSpecialities: "جميع التخصصات",
    loadingDoctors: "جاري تحميل الأطباء...",
    experience: "الخبرة",
    years: "سنوات",
    consultationFee: "رسوم الاستشارة",
    rating: "التقييم",
    reviews: "تقييمات",
    clinic: "العيادة",
    viewProfileBook: "عرض الملف الشخصي والحجز",
    doctorNotFound: "لم يتم العثور على الطبيب",
    backToDoctors: "العودة إلى الأطباء",
    symptomsReason: "الأعراض أو سبب الزيارة (اختياري)",
    describeSymptomsPlaceholder: "صف أعراضك أو سبب الموعد...",
    bookAppointmentFee: "حجز موعد - ${{fee}}",
    signInToBook: "يرجى تسجيل الدخول لحجز موعد",
    
    // Authentication
    continueWithGoogle: "المتابعة مع جوجل",
    continueWithPhone: "أو المتابعة بالهاتف",
    phoneNumber: "رقم الهاتف",
    sendCode: "إرسال رمز التحقق",
    verificationCode: "رمز التحقق",
    verifyCode: "تحقق من الرمز",
    changePhone: "تغيير رقم الهاتف",
    createAccount: "إنشاء حساب",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    dontHaveAccount: "ليس لديك حساب؟",
    
    // Logout
    logout: "تسجيل الخروج",
    loggingOut: "جاري تسجيل الخروج...",
    completeLogout: "تسجيل الخروج الكامل",
    signOutAllDevices: "تسجيل الخروج من جميع الأجهزة",
    logoutAs: "تسجيل الخروج كـ",
    keepOtherRoles: "الاحتفاظ بالأدوار الأخرى نشطة",
    emergencyLogout: "تسجيل الخروج الطارئ",
    clearAllData: "مسح جميع البيانات والجلسات",
    logoutSecurityNote: "من أجل الأمان، سيؤدي تسجيل الخروج إلى مسح جميع البيانات الطبية المخزنة مؤقتاً",
    searchSubtitle: "ابحث عن أطباء وعيادات وخدمات رعاية صحية بالقرب منك",
    allSpecialities: "جميع التخصصات",
    noResults: "لم يتم العثور على نتائج",
    adjustSearch: "جرب تعديل مصطلحات البحث أو المرشحات",
    searchHealthcareProviders: "البحث عن مقدمي الرعاية الصحية",
    findDoctorsClinicsServices: "ابحث عن أطباء وعيادات وخدمات رعاية صحية بالقرب منك",
    searchDoctorsClinics: "ابحث عن أطباء، عيادات...",
    allResults: "الكل",
    doctorsResults: "الأطباء",
    clinicsResults: "العيادات",
    searchButton: "بحث",
    searching: "جاري البحث...",
    resultsFound: "نتائج تم العثور عليها",
    
    // Appointments
    myAppointments: "مواعيدي",
    noAppointments: "لم يتم العثور على مواعيد",
    noAppointmentsDesc: "لم تحجز أي مواعيد بعد.",
    findDoctor: "ابحث عن طبيب",
    appointmentConfirmed: "تم تأكيد الموعد بنجاح!",
    
    // Medical Records
    medicalRecords: "السجلات الطبية",
    medicalRecordsSubtitle: "أدر واشارك سجلاتك الطبية بأمان",
    uploadRecord: "رفع سجل",
    myRecords: "سجلاتي",
    sharedRecords: "السجلات المشتركة",
    noRecordsFound: "لا توجد سجلات طبية",
    uploadFirst: "ارفع أول سجل طبي لك للبدء",
    
    // Clinic Dashboard
    clinicDashboard: "لوحة العيادة",
    manageAppointments: "إدارة المواعيد والجداول وإعدادات العيادة",
    calendarView: "عرض التقويم",
    locationSettings: "إعدادات الموقع",
    confirmAppointment: "تأكيد",
    rescheduleAppointment: "إعادة جدولة",
    sendSMS: "إرسال رسالة",
    
    // Common
    loading: "جاري التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    confirm: "تأكيد",
    back: "رجوع",
    next: "التالي",
    submit: "إرسال",
    close: "إغلاق",
    view: "عرض",
    download: "تحميل",
    share: "مشاركة",
    date: "التاريخ",
    time: "الوقت",
    status: "الحالة",
    payment: "الدفع",
    fee: "الرسوم",
    experience: "الخبرة",
    rating: "التقييم",
    location: "الموقع",
    about: "حول",
    symptoms: "الأعراض",
    
    // Status
    pending: "في الانتظار",
    confirmed: "مؤكد",
    completed: "مكتمل",
    cancelled: "ملغي",
    paid: "مدفوع",
    failed: "فشل",
    
    // Notifications
    newMessage: "رسالة جديدة من",
    appointmentConfirmedNotif: "تم تأكيد موعدك",
    appointmentRescheduled: "تم إعادة جدولة موعدك",
    reminderNotif: "تذكير: لديك موعد غداً",
    markAllRead: "تحديد الكل كمقروء",
    viewAllNotifications: "عرض كل الإشعارات",
    noNotifications: "لا توجد إشعارات",
    
    // Messages
    inbox: "صندوق الوارد",
    newMessage: "رسالة جديدة",
    sendMessage: "إرسال رسالة",
    typeMessage: "اكتب رسالتك...",
    noMessages: "لا توجد رسائل",
    startConversation: "ابدأ محادثة",
    
    // Language
    language: "اللغة",
    english: "English",
    arabic: "العربية",

    // Footer
    footerDescription: "منصتك الصحية الموثوقة التي تربط المرضى بالمهنيين الطبيين المعتمدين. رعاية عالية الجودة، متاحة للجميع.",
    quickLinks: "روابط سريعة",
    services: "الخدمات",
    onlineConsultation: "الاستشارة الإلكترونية",
    languageSettings: "اللغة",
    contact: "تواصل معنا",
    allRightsReserved: "جميع الحقوق محفوظة.",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",

    // About Us
    aboutUs: "من نحن",
    aboutUsTitle: "حول عناية هاب",
    aboutUsSubtitle: "نحن نثور على الرعاية الصحية من خلال جعل الرعاية الطبية عالية الجودة متاحة للجميع، في كل مكان.",
    ourMission: "مهمتنا",
    missionDescription: "في عناية هاب، نؤمن بأن الرعاية الصحية عالية الجودة يجب أن تكون متاحة للجميع. مهمتنا هي سد الفجوة بين المرضى ومقدمي الرعاية الصحية من خلال التكنولوجيا المبتكرة، وخلق تجربة رعاية صحية سلسة وفعالة للجميع.",
    accessibleHealthcare: "جعل الرعاية الصحية متاحة للجميع",
    qualityAndSafety: "ضمان الجودة والسلامة في كل تفاعل",
    innovativeTechnology: "استخدام التكنولوجيا المتطورة لنتائج أفضل",
    ourValues: "قيمنا",
    compassion: "التعاطف",
    compassionDescription: "نهتم بعمق برحلة كل مريض ونسعى لتقديم رعاية شخصية ومتفهمة.",
    excellence: "التميز",
    excellenceDescription: "نحافظ على أعلى المعايير في كل ما نقوم به، من منصتنا إلى شبكة مقدمي الخدمة لدينا.",
    innovation: "الابتكار",
    innovationDescription: "نطور تكنولوجيتنا باستمرار لتحسين تقديم الرعاية الصحية ونتائج المرضى.",
    ourTeam: "فريقنا",
    teamDescription: "فريقنا المتفاني من المهنيين الصحيين والتقنيين والمبتكرين يعمل بلا كلل لتحسين الوصول إلى الرعاية الصحية.",
    ceo: "الرئيس التنفيذي",
    ceoDescription: "يقود مهمتنا لتحويل إمكانية الوصول إلى الرعاية الصحية عالمياً.",
    cto: "كبير مسؤولي التكنولوجيا",
    ctoDescription: "يقود الابتكار والتميز التقني في منصتنا.",
    cmo: "كبير المسؤولين الطبيين",
    cmoDescription: "يضمن الجودة الطبية والسلامة في جميع خدماتنا.",

    // Demo Login
    demoMode: "الوضع التجريبي",
    demoModeDescription: "اختبر المنصة بأدوار مستخدمين مختلفة بدون تسجيل",
    selectRole: "اختر دوراً للاختبار:",
    patient: "مريض",
    doctor: "طبيب",
    provider: "مقدم خدمة",
    account: "حساب",
    cancel: "إلغاء", 
    loginAsDemo: "تسجيل دخول تجريبي",
    demoModeNote: "البيانات التجريبية مخصصة لأغراض الاختبار فقط",

    // Join as Provider
    joinAsProvider: "انضم إلى شبكة مقدمي الخدمة",
    joinAsProviderSubtitle: "وسع ممارستك واصل إلى المزيد من المرضى مع منصتنا الصحية الشاملة.",
    increasePatientBase: "زيادة قاعدة المرضى والظهور",
    streamlineScheduling: "تبسيط جدولة المواعيد وإدارتها",
    digitalPresence: "بناء حضور رقمي قوي لممارستك",
    securePayments: "معالجة آمنة للمدفوعات وحفظ السجلات",
    joinNow: "انضم الآن",
    learnMore: "اعرف المزيد"
  }
};

export default translations;